export default __webpack_public_path__ + "static/media/O-100.b2eaf066.png";